module.exports = __webpack_public_path__ + "static/media/Hero_Image_Tablet_9.6a350a9a.jpg";